import logo from './logo.svg';
import './App.css';
import { MyComponent } from './game';
function App() {
  return (
    <div style={{textAlign:"center"}}>
      <MyComponent></MyComponent>
    </div>
  );
}

export default App;
